import { Submission } from '@sky-distribution/gp-onboarding-policy-service/src/service/Policy.service.type';
import { CoverageType, CoverageWithMeta } from '../../Coverage.type';
import { getCurrentCoverages } from '../../coverageUtils';
import { SubmissionOptions } from '../GenericSubmission.type';

export const updateVariants = (
  selectedVariant: Submission['variants'][0],
  coverages: CoverageWithMeta[],
  submission: Submission,
  options: SubmissionOptions,
): Submission => {
  const currentConverges = getCurrentCoverages(coverages);

  return ({
    ...submission,
    variants: [
      {
        ...selectedVariant,
        [options.propertyKey]: selectedVariant[options.propertyKey] && {
          ...selectedVariant[options.propertyKey],
          [options.propertyCoveragesKey]: currentConverges.filter((coverage) => coverage.type === CoverageType.main)
            .map((coverage) => coverage.coverage),
        },
        coverages: currentConverges
          .filter((coverage) => coverage.type === CoverageType.additional)
          .map((coverage) => coverage.coverage),
      },
    ],
  });
};
